import React, { Component } from 'react';
import Images from './images';
import './styles.css';


class About extends Component {

    render() {

        const boxColor = 'red';

        const styles =  {

            box1: {
                color: 'red',
                height: '100px',
                width: '100px',
                backgroundColor: 'red'
            },
            box2: {
                color: 'blue',
                height: '100px',
                width: '100px',
                backgroundColor: 'blue'
            },
            box3: {
                color: 'green',
                height: '100px',
                width: '100px',
                backgroundColor: 'green'
            }


        };



        return (



            [


                <h1>About Page</h1>,

                <div style={styles.box1}></div>,
                <div style={styles.box2}></div>,
                <div style={styles.box3}></div>,
                <div style={styles.box1}></div>,





            ]

        )

    }
}



export default About;

